import React from 'react';
import { ThemeProvider } from 'emotion-theming';
import { baseTheme } from '@feast-it/ui/light';
import { DarkThemeProvider } from '../../context/DarkThemeContext';
import { IS_DARK_THEME } from '../../constants/theme';

interface IThemeWrapperUIProps {
  children: React.ReactNode;
}
export const ThemeWrapperUI: React.FC<IThemeWrapperUIProps> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={baseTheme}>
      <DarkThemeProvider enabled={IS_DARK_THEME}>{children}</DarkThemeProvider>
    </ThemeProvider>
  );
};
